import { Component, inject, input } from '@angular/core';
import { UserTrackingService } from '@myarvato/core/services';
import { CarrierNewsItemDto } from '../../../../models/carrier-news-item-dto';
import { DayjsPipe } from '@myarvato/shared/pipelines';
import { NewsModalComponent } from '../news-modal/news-modal.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MyArvatoDialogService } from '@myarvato/shared/dialog';

@Component({
  selector: 'transport-news-item',
  imports: [ButtonModule, DayjsPipe, TranslatePipe],
  templateUrl: './news-item.component.html',
  styleUrl: './news-item.component.scss',
})
export class NewsItemComponent {
  // Inputs
  public readonly newsItem = input.required<CarrierNewsItemDto>();

  // Injections
  private readonly dialogService = inject(MyArvatoDialogService);
  private readonly userTrackingService = inject(UserTrackingService);
  private readonly translateService = inject(TranslateService);

  // Fields
  protected readonly trackingCategory = 'Transport - Overview - News & Updates';

  protected onReadMoreClick() {
    this.userTrackingService.trackEvent(this.trackingCategory, 'Read more clicked');

    this.dialogService.showDialog(NewsModalComponent, {
      size: 'xl',
      header: this.translateService.instant('pages.transport.tracking-overview.widgets.news-updates.modal.headline'),
      inputValues: {
        newsItem: this.newsItem(),
      },
    });
  }
}
